import { SearchDriveItemAction, SearchDriveItemActionKeys } from './actions';

export interface SearchDriveItemState {
	isFetching: boolean;
	driveItemIds: number[];
	searchString?: string;
	isShown: boolean;
}

const initialState: SearchDriveItemState = {
	isFetching: false,
	driveItemIds: [],
	isShown: false
};

export function search(state: SearchDriveItemState = initialState, action: SearchDriveItemAction): SearchDriveItemState {
	switch (action.type) {
		case SearchDriveItemActionKeys.REQUEST_SEARCH:
			return {
				...state,
				searchString: action.searchString,
				isFetching: true
			};
		case SearchDriveItemActionKeys.RECEIVE_SEARCH:
			return {
				...state,
				isFetching: false,
				driveItemIds: action.driveItemIds
			};
		case SearchDriveItemActionKeys.RESET_SEARCH:
			return {
				...state,
				isFetching: false,
				driveItemIds: [],
			};
		case SearchDriveItemActionKeys.TOGGLE_SEARCH_FIELD_VISIBILITY:
			return { ...state, isShown: !state.isShown };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/reducer.ts